export default __webpack_public_path__ + "static/media/maori.1fb299b2.svg";